import { createAppAsyncThunk } from '../../store/extensions';
import {
  createCommentCall,
  createReplyToCommentCall,
  deleteCommentCall,
  fetchCommentsPaginatedCall,
  fetchModerationReasonsCall,
  fetchRepliesToCommentPaginatedCall,
  getCommentCall,
  getReplyCall,
  moderatorDeleteCommentCall,
  moderatorEditCommentCall,
  reportCommentCall,
  updateCommentCall,
  updateLikeCommentCall,
} from './service';
import { CreateLikeDto, ReplyDto } from '../../common';
import { ModeratorEditCommentDto } from './models';

export const fetchCommentsPaginated = createAppAsyncThunk(
  'community/post/comments/getPaginated',
  (args: { postId: string; numrecs?: number; xMsContinuation?: string }) => {
    return fetchCommentsPaginatedCall(
      args.postId,
      args.numrecs,
      args.xMsContinuation
    );
  }
);

export const fetchRepliesToCommentPaginated = createAppAsyncThunk(
  'community/post/repliesToComment/getPaginated',
  (args: {
    postId: string;
    commentId: string;
    numrecs?: number;
    xMsContinuation?: string;
  }) => {
    return fetchRepliesToCommentPaginatedCall(
      args.postId,
      args.commentId,
      args.numrecs,
      args.xMsContinuation
    );
  }
);

export const createComment = createAppAsyncThunk(
  'community/post/replies/create',
  (args: { newReply: ReplyDto; roomId: string; postId: string }) => {
    return createCommentCall(args.newReply, args.roomId, args.postId);
  }
);

export const createReplyToComment = createAppAsyncThunk(
  'community/post/replyToComment/create',
  (args: {
    newReply: ReplyDto;
    roomId: string;
    postId: string;
    commentId: string;
  }) => {
    return createReplyToCommentCall(
      args.newReply,
      args.roomId,
      args.postId,
      args.commentId
    );
  }
);

export const updateLikeComment = createAppAsyncThunk(
  'community/post/replies/like',
  (args: {
    like: CreateLikeDto;
    roomId: string;
    postId: string;
    replyId: string;
    commentId?: string;
  }) => {
    return updateLikeCommentCall(
      args.like,
      args.roomId,
      args.postId,
      args.replyId
    );
  }
);

export const deleteComment = createAppAsyncThunk(
  'community/post/comment/delete',
  (args: { postId: string; replyId: string; commentId?: string }) => {
    return deleteCommentCall(args.postId, args.replyId);
  }
);

export const updateComment = createAppAsyncThunk(
  'community/post/comment/update',
  (args: {
    postId: string;
    replyId: string;
    updateReply: ReplyDto;
    commentId?: string;
  }) => {
    return updateCommentCall(args.postId, args.replyId, args.updateReply);
  }
);

export const fetchComment = createAppAsyncThunk(
  'community/post/comment/get',
  (args: { postId: string; commentId: string }) => {
    return getCommentCall(args.postId, args.commentId);
  }
);

export const fetchSelectedComment = createAppAsyncThunk(
  'community/post/comment/selected/get',
  (args: { postId: string; commentId: string }) => {
    return getCommentCall(args.postId, args.commentId);
  }
);

export const fetchReply = createAppAsyncThunk(
  'community/post/reply/get',
  (args: { postId: string; replyId: string }) => {
    return getReplyCall(args.postId, args.replyId);
  }
);

export const reportComment = createAppAsyncThunk(
  'community/post/comment/report',
  (args: { postId: string; commentId: string }) => {
    return reportCommentCall(args.postId, args.commentId);
  }
);

export const moderatorDeleteComment = createAppAsyncThunk(
  'community/moderator/deleteComment',
  (args: { postId: string; commentId: string; parentCommentId?: string }) => {
    return moderatorDeleteCommentCall(args.postId, args.commentId);
  }
);

export const moderatorEditComment = createAppAsyncThunk(
  'community/moderator/editComment',
  (args: {
    postId: string;
    commentId: string;
    editCommentDto: ModeratorEditCommentDto;
  }) => {
    return moderatorEditCommentCall(
      args.postId,
      args.commentId,
      args.editCommentDto
    );
  }
);

export const fetchModerationReasons = createAppAsyncThunk(
  'community/moderator/moderationReasons/get',
  () => {
    return fetchModerationReasonsCall();
  }
);
